import React from "react";

export const PageEnglish7 = () => {
  return (
    <div className="page-container">
      <p>
        I thought that it was okay to spend our money, and that the money given
        by others should be spent with care and consideration. However, I
        cooperated with Mr. S. Durairaj with the thought and joy that we were
        going to fulfill the long-standing desire of the villagers and I think
        that I have completed the task assigned to me well. I did not accept
        this task for fame, glory, selfishness, or name. I accepted the
        responsibility on the basis that the people wanted it, Adhiyannan and
        Ayyanar gave orders, and Durairaj extended a loving hand.
      </p>
      <p>
        My thanks to the abbot who supported me and completed the work on time
        and installed the new idol, Mr. R. Soundarajan, who painted it and Mr.
        Thiyaku, who provided various assistance and cooperation!
      </p>
      <p>
        The temple structure, idol structure, yagasala structure, and
        Kumbabhishekam ceremonies were all done according to the advice and
        supervision of our beloved Mr. Veeramani Sivacharya Ayya, who knows the
        rules of Agama. I also express my gratitude to Ayya. With love,
        <strong> G.Ramesh.</strong>
      </p>

      <p>
        The founder of Sri Poornamya Pushpalambika Sametha Ayyanar Temple, the
        idols of the divine Adhiyannan idol, R. Soundararajan, says:
      </p>
      <p>
        I have installed idols in many temples so far. But the idols installed
        in this temple are idols beyond my power.
      </p>
      <p>
        One day, my friend Ramesh, a Bangalore devotee, Mr. Durairaj's family
        wanted to renovate the Adhiyannan temple. You should do the work. He
        took me to the temple. Then I met Durairaj and we planned what kind of
        work should be done for the renovation. They wanted to install a new
        idol of Adhiyannan. As per the custom, I started talking after getting
        the order to install a new idol by tying flowers. I asked them what the
        idol should be like. The height should be medium, about the height of a
        man. The idol should be majestic. It should have a beautiful appearance.
        It should have a structure with eyes that shower mercy.
      </p>
      <p>
        I asked for a certain amount to build such a statue. Let's not talk
        about money now. We will buy the necessary materials. We will pay the
        requested wages - they said the statue should be as mentioned above.
      </p>
    </div>
  );
};
